const tours = {
  availableEscapes: "Escapades disponibles", // translated
  addOns: "Modules complémentaires", // translated
  tours: "Visites", // translated
  addOn: "Ajouter sur", // translated
  sendRequest: "Envoyer une demande", // translated
  availableExperiences: "Expériences disponibles", // translated
  selectRoom: "Sélectionnez une chambre", // translated
  tour: "Tournée", // translated
  getRequest: "Obtenir une demande", // translated
};

export default tours;
